// extracted by mini-css-extract-plugin
export default {"mCard":"EC-z","image":"FC-z","imageNoBackground":"GC-z","imageHasCategory":"HC-z","fullWidth":"IC-z"};